import { render, staticRenderFns } from "./QuizTeacherCreateQuestion.vue?vue&type=template&id=20cfeec7&"
import script from "./QuizTeacherCreateQuestion.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherCreateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherCreateQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports